import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { TextField } from '../../../../../components/material-ui/TextField';

export const AlertTextfield = memo(({ value, changeHandler, timerType }) => {
    const { t: translate } = useTranslation();
    const handleChange = ({ currentTarget: { value } }) => changeHandler({ [timerType]: +value.replace(/^0+/, '') });

    return (
        <TextField
            required={true}
            type="number"
            label={translate('enterMinutes')}
            value={value.toString()}
            onChange={handleChange}
            fullWidth={true}
            inputProps={{ min: 0 }}
        />
    );
});
